import type { ProductReviewsSummary } from '../../types';

const STAR_LEVELS = [5, 4, 3, 2, 1] as const;

interface RatingDistributionProps {
  summary: ProductReviewsSummary;
}

interface ProgressRowProps {
  starLevel: number;
  count: number;
  total: number;
}

function ProgressRow({ starLevel, count, total }: ProgressRowProps) {
  const percentage = total > 0 ? (count / total) * 100 : 0;

  return (
    <div style={{ display: 'flex', gap: '12px', alignItems: 'center', width: '100%' }}>
      <div
        style={{
          width: '12px',
          textAlign: 'right',
          color: 'var(--product-reviews-distribution-text-color, var(--text-light))',
          fontSize: 'var(--product-reviews-distribution-font-size, 16px)',
          fontFamily: 'var(--product-reviews-distribution-font-family, inherit)',
          lineHeight: '24px',
        }}
      >
        {starLevel}
      </div>
      <div
        style={{
          flex: 1,
          position: 'relative',
          height: '8px',
          borderRadius: '8px',
          backgroundColor: 'var(--product-reviews-distribution-bar-bg-color, var(--text-light))',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            borderRadius: '8px',
            backgroundColor: 'var(--product-reviews-distribution-bar-color, var(--accent))',
            width: `${percentage}%`,
          }}
        />
      </div>
      <div
        style={{
          width: '32px',
          fontWeight: 510,
          color: 'var(--product-reviews-distribution-text-color, var(--text))',
          fontSize: 'var(--product-reviews-distribution-font-size, 16px)',
          fontFamily: 'var(--product-reviews-distribution-font-family, inherit)',
          lineHeight: '24px',
        }}
      >
        {count}
      </div>
    </div>
  );
}

export function RatingDistribution({ summary }: RatingDistributionProps) {
  const totalReviews = summary.total_reviews_count;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      {STAR_LEVELS.map((starLevel) => (
        <ProgressRow
          key={starLevel}
          starLevel={starLevel}
          count={summary.scores_to_counts_map[starLevel]}
          total={totalReviews}
        />
      ))}
    </div>
  );
}
